import { render } from "./AdminCanalNavReview.vue?vue&type=template&id=45ab33dd&scoped=true"
import script from "./AdminCanalNavReview.vue?vue&type=script&lang=js"
export * from "./AdminCanalNavReview.vue?vue&type=script&lang=js"

import "./AdminCanalNavReview.vue?vue&type=style&index=0&id=45ab33dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ab33dd"]])

export default __exports__